export class NotePatientType {
    patient = null;
    content = null;
    remark = null;
    department = null;
    noteCreator = null;
    // noteDate = null;
}